// exports
window.hypertherm = window.hypertherm || {};
window.hypertherm.pagination = window.hypertherm.pagination || {};
window.hypertherm.pagination.paginationObjects = [];

document.addEventListener("DOMContentLoaded", function () {
    const paginationElements = document.querySelectorAll("[pagination]");

    if (paginationElements.length > 0) {
        import(/* webpackChunkName: "pagination" */ "/Features/Pagination/js/pagination.js").then(async (module) => {

            paginationElements.forEach(el => {
                const pagination = new module.default(el);
                window.hypertherm.pagination.paginationObjects.push(pagination);
            });
        });
    }
});